const API_URL = process.env.REACT_APP_API_URL
import BaseApi from "./baseApi"

class AwardsApi extends BaseApi {
  constructor() {
    super()
    this.baseUrl = "/awards"
    this.baseEventUrl = "/events"
  }

  getAwardDetails(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-award-details/${data}`
    const axiosRq = {
      url: endPoint,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  addAwardNomination(data, token) {
    console.log("addAwardNomination api invoked..", data, token)

    const endPoint = `${API_URL}${this.baseUrl}/add-award-nomination`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createOrderAwardNomination(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/create-order-award-nomination`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  verifyAwardNominationPayment(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/verify-award-nomination-payment`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  addAwardShortlistedDetails(data, token) {
    console.log("addAwardShortlistedDetails api invoked..", data, token)

    const endPoint = `${API_URL}${this.baseUrl}/add-award-shortlisted-details`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  // ADMIN

  getAwardsList(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-award-list`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getNominationList(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-awards-nomination-list`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getNominationDetails(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-award-nomination-details/${data}`
    const axiosRq = {
      url: endPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getAwardsCategoryList(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-award-category-list`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updateNomination(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/update-award-nomination`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
}

const awardsApi = new AwardsApi()

export default awardsApi
